import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Col, Row, Card, Form } from '@themesberg/react-bootstrap'
import { Context } from '../Reward'
import { getSummaryBigReward } from '../../../../controller/api/__vietlott__/reward'
import { useCookies } from 'react-cookie';

const _Summary = () => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [summary, setSummary] = useState({
    gross: 0,
    tax: 0,
    fee: 0,
    net: 0,
    count: 0,
    unPaided: 0
  })

  const getSummaryFunc = useCallback(async () => {
    let phone = state.filter.phone

    const response = await getSummaryBigReward(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      phone: phone,
      gameId: state.filter.gameId,
      deviceId: state.filter.deviceId,
      level: state.filter.group == 'A' ? '9,10' : state.filter.group == 'B' ? '0,1,2,3,4,5,6,7,8' : '0,1,2,3,4,5,6,7,8,9,10',
    })

    if (response) {
      const res = {
        gross: response.gross,
        tax: response.tax,
        fee: response.fee,
        net: response.net,
        count: response.count,
        unPaided: response.unPaided
      }
      setSummary(res || {})
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone, state.filter.gameId, state.filter.deviceId, state.filter.group])

  const listSumary = useMemo(() => {
    return (
      <>
        <Col md={2} sm={12}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Số lượng vé"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.count) || ""}</Form.Label>
          </Row>
        </Col>
        <Col md={2} sm={12}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Giải thưởng"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.gross) || ""}</Form.Label>
          </Row>
        </Col>
        <Col md={2} sm={12}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Phí"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.fee) || ""}</Form.Label>
          </Row>
        </Col>
        <Col md={2} sm={12}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Thuế"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.tax) || ""}</Form.Label>
          </Row>
        </Col>
        <Col md={2} sm={12}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Thực nhận"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.net) || ""}</Form.Label>
          </Row>
        </Col>
        <Col md={2} sm={12}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Chưa trả thưởng"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.unPaided) || ""}</Form.Label>
          </Row>
        </Col>
      </>
    )
  }, [summary])

  useEffect(() => {
    getSummaryFunc()
  }, [getSummaryFunc, state.filterPressCount])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Body>
          <Row>
            {state.loading ? <h2 className='text-center'>Đang tải dữ liệu</h2> :
              listSumary}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_Summary)